import { useContext } from "react";
import ErrorHandlingContext from "./ErrorHandlingContext";

const useErrorHandling = () => {
  const context = useContext(ErrorHandlingContext);
  if (context === undefined) {
    throw new Error("useErrorHandling must be used within an ErrorHandlingProvider");
  }
  return context;
};

export default useErrorHandling;
